import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { useAuth } from '../../hooks/useAuth'
import { setReiniciaFiltros } from '../../slices/filterSlice'
import * as notificacionesService from '../servicios/notificacionesService'
import LinkButton from '../ui/LinkButton'
import styles from './DropdownNotificacion.module.css'

const CANT_MAX_NOTIFICACIONES = 99
const NOTIFICACION_CARGA_MASIVA = 11

const DropdownNotificacion = ({ refreshKey }) => {
  const [notificaciones, setNotificaciones] = useState([])
  const [notificacionExistente, setNotificacionExistente] = useState(false)
  const [notificacionLeida, setNotificacionLeida] = useState(0)
  const dispatch = useDispatch()
  const { loginDataContext: { idUsuario: idUsuarioChat } = {} } = useAuth()

  const location = useLocation()

  const fetchNotificaciones = async () => {
    const { data } = await notificacionesService.buscarPorMensaje(idUsuarioChat)
    setNotificaciones(data)
    if (data.length !== 0) {
      setNotificacionLeida(data.filter((n) => n.fechaLeido === null).length)
      setNotificacionExistente(true)
    }
  }
  useEffect(() => {
    if (idUsuarioChat) {
      fetchNotificaciones()
    }
  }, [location.pathname, refreshKey, idUsuarioChat])

  const handleClickNotificacion = async (idMensaje) => {
    if (notificaciones.find((n) => n.idMensaje === idMensaje)?.fechaLeido !== null) return
    try {
      await notificacionesService.actualizarNotificacion({ idMensaje })
      contador(idMensaje)
      dispatch(setReiniciaFiltros(true))
    } catch (error) {
      toastErrorLog(error, 'Ocurrió un error al actualizar la notificación.', 'notificacion')
    }
  }

  const obtenerURL = (
    tipoNotificacion,
    idPresupuesto,
    idPublicacion,
    idPedidoItem,
    idVendedor,
    idPedido,
    idComprador,
    idMensajeTipo
  ) => {
    if (idMensajeTipo === NOTIFICACION_CARGA_MASIVA) {
      return '/CargaMasiva'
    }
    let path
    switch (tipoNotificacion) {
      case 'PRESUPUESTO':
        path = `/Presupuesto/${idPresupuesto}`
        break

      case 'PUBLICACION':
        path = {
          pathname: `/${idVendedor === idUsuarioChat ? 'PreguntasVendedor' : 'PreguntasComprador'}`,
          state: {
            idPublicacion,
            idVendedor,
            idComprador: idVendedor === idUsuarioChat ? idComprador : null
          }
        }
        break
      case 'COMPRAS':
        path = `/PedidoItem/${idPedidoItem}`
        break
      case 'PEDIDO_CABECERA': {
        const esVentas = idVendedor === idUsuarioChat
        path = {
          pathname: `/Pedido/${idPedido}`,
          state: { esVentas }
        }
        break
      }
      case 'PUBLICACION_VENCIDA':
        path = `/Publicaciones/Administrar`
        break
      case 'TIENDA_OFICIAL':
        path = `/ConvertirTiendaOficial`
        break
      default:
        path = `/PedidoItem/${idPedidoItem}`
    }
    return path
  }

  const contador = (idMensaje) => {
    const notificacionActualizada = notificaciones.map((n) => {
      return n.idMensaje === idMensaje
        ? { ...n, fechaLeido: n.fechaLeido === null ? 'leido' : null }
        : n
    })

    setNotificaciones(notificacionActualizada)
    setNotificacionLeida(notificacionActualizada.filter((n) => n.fechaLeido === null).length)
  }

  const handleToggleLeido = async (e, idMensaje) => {
    e.preventDefault()
    e.stopPropagation()
    try {
      await notificacionesService.actualizarNotificacion({ idMensaje })
      contador(idMensaje)
    } catch (error) {
      toastErrorLog(error, 'Ocurrió un error al actualizar la notificación.', 'notificacion')
    }
  }

  return (
    <>
      <Dropdown id="drop-mobile-style">
        <Dropdown.Toggle id="drop-toggle-style">
          <div className="btn btn-notificaciones">
            <span
              className={`fa fa-bell ${
                notificacionLeida > 0 ? styles.color_bell_notification : ''
              }`}
            ></span>
            <span className="badge badge-light">
              {notificacionLeida > CANT_MAX_NOTIFICACIONES ? '99+' : notificacionLeida}
            </span>
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu
          className={
            notificacionExistente
              ? styles.dropdown_link_notificacion
              : styles.contenedor_notificaciones_vacias
          }
        >
          {notificacionExistente ? (
            notificaciones.map((notificacion) => {
              const tieneTitulo = notificacion.titulo || notificacion.idPedido > 0
              return (
                <Dropdown.Item
                  as={LinkButton}
                  to={obtenerURL(
                    notificacion.tipoNotificacion,
                    notificacion.idPresupuesto,
                    notificacion.idPublicacion,
                    notificacion.idPedidoItem,
                    notificacion.idVendedor,
                    notificacion.idPedido,
                    notificacion.idComprador
                  )}
                  key={notificacion.idMensaje}
                  onClick={() =>
                    handleClickNotificacion(notificacion.idMensaje, notificacion.fechaLeido)
                  }
                  className={`${styles.estilo} ${styles.item_notificacion} ${notificacion.fechaLeido === null ? styles.item_no_leido : ''}`}
                >
                  <span
                    role="button"
                    title={
                      notificacion.fechaLeido === null
                        ? 'Marcar como leída'
                        : 'Marcar como no leída'
                    }
                    onClick={(e) => handleToggleLeido(e, notificacion.idMensaje)}
                    className={`fa fa-circle ${notificacion.fechaLeido === null ? styles.circulo_dot : styles.circulo_dot_leido}`}
                  />
                  <div
                    className={`${styles.notificacion_nueva} ${notificacion.fechaLeido === null ? styles.texto_no_leido : ''}`}
                  >
                    <span className={styles.encabezado_notificacion}>
                      {tieneTitulo
                        ? `${notificacion.mensajeSistema} en`
                        : notificacion.mensajeSistema}
                    </span>
                    {tieneTitulo && (
                      <b className={styles.titulo_notificacion_publicacion}>
                        {notificacion.titulo || `Pedido #${notificacion.idPedido}`}
                      </b>
                    )}
                    <div className={styles.texto_notificacion}>{notificacion.texto}</div>
                  </div>
                </Dropdown.Item>
              )
            })
          ) : (
            <div className="notificaciones-vacias">Aún no tienes notificaciones.</div>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </>
  )
}

DropdownNotificacion.propTypes = {
  refreshKey: PropTypes.number
}

export default DropdownNotificacion
